module.exports = __webpack_public_path__ + "static/p05_cencerro-0bce6563503d10b7d985c7fa9f6875ae.png";